const inProd = process.env.NODE_ENV === "production";

const config = {
  inProd,
  cookies: {
    consentCookieLabel: "consent-cookie",
  },
  emails: {
    support: inProd ? process.env.REACT_APP_SUPPORT_EMAIL : "support@localhost",
    team: inProd ? process.env.REACT_APP_TEAM_EMAIL : "team@localhost",
  },
  links: {
    affiliateProgram:
      "mailto:team@goviralstrategy.com?subject=Referral Program Application&body=Hi, I'd like to join the referral program.%0D%0A%0D%0APlease find my details below:%0D%0A%0D%0AEmail: %0D%0ASocial Media Profiles: %0D%0A%0D%0AThank you!",
    baseWebURL: "https://goviralstrategy.com",
    baseAPIURL: inProd
      ? process.env.REACT_APP_API_URL
      : "http://localhost:4000",
    blog: "https://goviralstrategy.com/blog.html",
    newsletter: inProd
      ? process.env.REACT_APP_BLOG_URL
      : "https://substack.com/@goviralstrategy",
    legal: "/legal/terms",
    pricing: "https://goviralstrategy.com/#pricing",
    stripeCustomerPortalURL: inProd
      ? "https://billing.stripe.com/p/login/14k00he561TqeaIfYY"
      : "https://billing.stripe.com/p/login/test_aEU7sK9ST2Ki0Xm9AA",
  },
  turnstile: {
    siteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY || "",
  },
};

export default config;
